import React from 'react';
import {useQuery} from 'react-query';
import {Button, Spinner} from 'reactstrap';
import {RefreshCwIcon} from 'lucide-react';
import {
    SavedTranslationRow,
    useSavedTranslation
} from '../../api/assistant/savedTranslations.ts';
import AssistantOutput from '../assistant/AssistantOutput';
import Icon from '../shared/Icon.tsx';
import {modeLabel, savedAgo} from './savedTranslationFormat.ts';

interface SavedTranslationOutputProps {
    row: SavedTranslationRow;
    onRemove: () => void;
    // Only offered on the page it was made for.
    onTranslateAgain?: () => void;
}

// A saved translation, opened from the panel's list: no AI call.
const SavedTranslationOutput: React.FC<SavedTranslationOutputProps> = ({
    row,
    onRemove,
    onTranslateAgain
}) => {
    const fetchSaved = useSavedTranslation(row.id);
    const {data, isLoading} = useQuery(
        ['saved-translation', row.id],
        fetchSaved
    );

    if (isLoading || !data) {
        return <Spinner type="grow" size="sm" color="primary" />;
    }

    return (
        <AssistantOutput
            id={row.id}
            title={`${data.language} ${modeLabel(data.mode).toLowerCase()}`}
            initialText={data.output}
            onRemove={onRemove}
            subtitle={
                <>
                    Saved {savedAgo(data.createdOnUtc)}
                    {row.outOfDate &&
                        '. This page has changed since, so it may be out of date.'}
                </>
            }
            actions={
                onTranslateAgain && (
                    <Button
                        color="link"
                        size="sm"
                        className="p-0 ms-3"
                        onClick={onTranslateAgain}
                    >
                        <Icon icon={RefreshCwIcon} size="xs" /> Translate again
                    </Button>
                )
            }
        />
    );
};

export default SavedTranslationOutput;
